const visualizationInitial = {
    data: null,
    loading: false,
    selectedPage: undefined,
    totalPages: undefined,
    loadedVisualization: undefined,
    saving: false
}

const initialState = {
    visualizations: { ...visualizationInitial }
}

export { initialState as visualizationsInitialState, visualizationInitial };